// extracted by mini-css-extract-plugin
export var contentContainer = "+rKy2";
export var contentOrigin = "ZR7RG";
export var root = "tturn";